/* Checkout guard: a code from a shared link (/discount/CODE or ?discount=CODE)
   sits on the cart even when it is fake, expired or not valid for the bag,
   and Shopify carries it into checkout. Before leaving for checkout, drop every
   code the cart reports as not applicable, keep the ones that apply, then go.
   Covers the cart page buttons (a[href="/checkout"]) and the cart drawer
   button (name="checkout"). The free gift line is synced first. */
(function () {
  if (window.ORWCheckoutGuard) return;
  window.ORWCheckoutGuard = true;

  var CHECKOUT = '/checkout';

  function cleanCodes() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var keep = codes.filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
        if (keep.length === codes.length) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: keep.join(',') })
        });
      })
      .catch(function () { /* never block checkout */ });
  }

  function go(e, el) {
    if (el.getAttribute('aria-disabled') === 'true' || el.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    if (el.dataset.orwGuardBusy) return;
    el.dataset.orwGuardBusy = '1';
    // Free gift first (orw-free-gift.js), so checkout gets the right bag; then the codes
    var gift = window.ORWFreeGift ? window.ORWFreeGift.sync() : Promise.resolve();
    gift.then(cleanCodes, cleanCodes).then(function () { window.location.href = CHECKOUT; });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var el = e.target.closest('a[href="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (el) go(e, el);
  }, true);
})();
